import { render } from "./Modele_5.vue?vue&type=template&id=23ff0303&scoped=true"
import script from "./Modele_5.vue?vue&type=script&lang=js"
export * from "./Modele_5.vue?vue&type=script&lang=js"

import "./Modele_5.vue?vue&type=style&index=0&id=23ff0303&scoped=true&lang=css"

import exportComponent from "/home/runner/work/logexpo/logexpo/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-23ff0303"]])

export default __exports__
import QIcon from 'quasar/src/components/icon/QIcon.js';
import qInstall from "../../../node_modules/vue-cli-plugin-quasar/lib/runtime.auto-import.js";
qInstall(script, 'components', {QIcon});
